import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonConfig } from '@libraries/design-system';

@Component({
  selector: 'footer-desktop',
  templateUrl: './footer-desktop.component.html',
  styleUrls: ['./footer-desktop.component.scss'],
  standalone: false,
})
export class FooterDesktopComponent {
  @Input() layout: 'apart' | 'adjacent';

  // PRIMARY BUTTON CONFIG
  private _primary: ButtonConfig;
  @Input()
  set primary(config: ButtonConfig) {
    if (config) this._primary = { ...config, rank: 'primary' };
  }
  get primary() {
    return this._primary;
  }
  @Input() secLoading: boolean;
  @Input() secDisabled: boolean;

  // SECONDARY BUTTON CONFIG
  private _secondary: ButtonConfig;
  @Input()
  set secondary(config: ButtonConfig) {
    if (config) this._secondary = { ...config, rank: 'secondary' };
  }
  get secondary() {
    return this._secondary;
  }
  @Input() primLoading: boolean;
  @Input() primDisabled: boolean;

  // CLICK OUTPUTS
  @Output() primaryClicked = new EventEmitter();
  @Output() secondaryClicked = new EventEmitter();

  constructor() {}

  primaryAction() {
    this.primaryClicked.emit();
  }

  secondaryAction() {
    this.secondaryClicked.emit();
  }
}
